import { Product } from "../productsData";

function productsData(): Product[] {
  return [
    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-15",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-15`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1661588492/shopping%20cart/half%20sleeve%20cut/mthcssp15-solid-920x920_him69g.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 15)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },

    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-14",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-14`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663328381/shopping%20cart/half%20sleeve%20cut/productPage/mthcssp14-solid-920x920_eguvr2.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 14)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },

    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-13",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-13`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663328399/shopping%20cart/half%20sleeve%20cut/productPage/mthcssp13-solid-920x920_meukku.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 13)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },

    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-12",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-12`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663328549/shopping%20cart/half%20sleeve%20cut/productPage/mthcssp12-solid-920x920_fldnp4.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 12)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },

    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-11",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-11`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663328545/shopping%20cart/half%20sleeve%20cut/productPage/mthcssp11-solid-920x920_fk9tcc.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 11)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },

    {
      path: "/half-sleeve-cut-and-sew-solid-pattern-10",
      fullPath: `/half-sleeve-cut-and-sew-solid/product/half-sleeve-cut-and-sew-solid-pattern-10`,
      imagesForProductPage: [
        "https://res.cloudinary.com/du3oueesv/image/upload/v1663328541/shopping%20cart/half%20sleeve%20cut/productPage/mthcssp10-solid-920x920_omjbhg.jpg",
      ],
      breadCrumbs: [
        {
          name: "HOME",
          path: "/",
        },
        {
          name: "HALF SLEEVE CUT T-SHIRTS",
          path: "/half-sleeve-cut-and-sew-solid",
        },
      ],
      name: "Half Sleeve Cut and Sew Solid(pattern 10)",
      price: "৳450.00",
      details: ["Fabric: 100% Cotton", "GSM: 160-165"],
      fabric: ["COMBED COTTON"],
      color: [],
      size: ["M", "L", "XL", "XXL"],
      description: [
        "M(Medium): Chest 39.37″ inch/ 100 cm, Height 27.55″ inch/ 70 cm",
        "L(large) : Chest 40.94″inch/ 104 cm, Height 28.34″inch/ 72 cm",
        "XL(Extra large): Chest 42.51″ inch/ 108 cm, Height 29.13″ inch/ 74 cm",
        "XXL(Extra large) : Chest 44.09″ inch/ 112 cm, Height 29.92″ inch/ 76 cm",
      ],
      additionalInfo: {
        weight: "0.13kg",
        fabric: "COMBED COTTON",
        size: "M, L, XL, XXL",
      },
    },
  ];
}

function getProductData(searchPath: string) {
  return (
    productsData().find((product) => {
      const productPath = product.path?.split("/").pop();
      return productPath === searchPath;
    }) || productsData()[0]
  );
}

export default getProductData;
